import { RugbyLeagueMatchConfig } from '@ligr/api-v2';
import { FormikProps, useFormikContext, FormikContextType } from 'formik';
import React from 'react';
import { FormField } from '../../../components/FormField';
import { Title } from '../../../components/Title/Title';
import { MatchFormValues } from '../NewMatchPage/Form/types';

export const RugbyLeagueMatchFormConfigFields: React.FunctionComponent<FormikProps<MatchFormValues> & {
  disabled: boolean;
  configKey: string;
  form: FormikContextType<any>;
}> = props => {
  const { disabled } = props;
  const values = props.form.values;

  const config = values.config as RugbyLeagueMatchConfig;

  return (
    <>
      <section className="rugbyLeagueConfigFields__matchSettings">
        <Title is3 className="">
          Match settings
        </Title>
        <FormField
          type="text"
          name="config.regularPeriodLength"
          label="Half length"
          colSpan={1}
          suffix="mins"
          disabled={disabled}
          value={values.config.regularPeriodLength}
        />
        <FormField
          type="text"
          name="config.regularHalftimeLength"
          label="Half time length"
          colSpan={1}
          suffix="mins"
          disabled={disabled}
          value={values.config.regularHalftimeLength}
        />
        <FormField
          type="switch"
          name="config.goldenPoint"
          label="Golden Point"
          colSpan={1}
          disabled={disabled}
          value={values.config.goldenPoint}
        />
        {config?.goldenPoint && (
          <>
            <FormField
              type="text"
              name="config.preOvertimeBreakLength"
              label="Pre Golden Point break length"
              colSpan={1}
              suffix="mins"
              disabled={disabled}
              value={values.config.preOvertimeBreakLength}
            />
            <FormField
              type="text"
              name="config.extratimePeriodLength"
              label="Golden Point half length"
              colSpan={1}
              suffix="mins"
              disabled={disabled}
              value={values.config.extratimePeriodLength}
            />
            <FormField
              type="text"
              name="config.extratimeHalftimeLength"
              label="Golden Point break length"
              colSpan={1}
              suffix="mins"
              disabled={disabled}
              value={values.config.extratimeHalftimeLength}
            />
          </>
        )}
      </section>
      <section className="rugbyLeagueConfigFields__matchSettings">
        <Title is3 className="createMatch__column__sportConfig__title">
          Data Coverage
        </Title>
        <FormField
          type="radio-tab"
          name="config.dataCoverage.stats"
          options={[
            { value: 'minimum', label: 'Minimum' },
            { value: 'standard', label: 'Standard' }
          ]}
          colSpan={2}
          disabled
          value={values.config.dataCoverage.stats}
        />
        <FormField
          type="switch"
          name="config.dataCoverage.players"
          label="Players"
          colSpan={1}
          disabled={disabled}
          value={values.config.dataCoverage.players}
        />
        <FormField
          type="switch"
          name="config.dataCoverage.possession"
          label="Possession"
          colSpan={1}
          disabled={disabled}
          value={values.config.dataCoverage.possession}
        />
      </section>
    </>
  );
};
